import gql from 'not-graphql-tag';

export const getSalesforceEncryptedAccountNumberQuery = gql`
  query getSalesforceEncryptedAccountNumber(
    $payload: SalesforceEncryptedAccountNumberInput!
  ) {
    getSalesforceEncryptedAccountNumber(payload: $payload)
  }
`;
